import styled from 'styled-components'

export const ContainerDesenho = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;

  .Content__map {
    width: calc(100% - 300px);
    height: 100%;
    border-radius: 16px;
    overflow: hidden;
    position: relative;

    .Content__map__options {
      width: 310px;
      border-radius: 8px;
      background: #fff;
      position: absolute;
      top: 12px;
      left: 12px;
      z-index: 2;
      box-sizing: border-box;
      padding: 12px;

      .Content__map__options__inputs {
        margin-top: 4px;
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
    }
  }
`

export const Painel = styled.div`
  position: absolute;
  top: 68px;
  left: 40px;
  width: 267px;
  background-color: #fff;
  border-radius: 7px;
  box-sizing: border-box;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: 0.4s;
`

export const Container = styled.div`
  .ant-drawer-body {
    padding: 0;
  }
`

export const Tools = styled.div`
  position: absolute;
  display: flex;
  justify-content: end;
  width: 20rem;
  height: 90vh;
  right: 0;
  margin: 1rem;
`

export const CardDados = styled.div`
  position: absolute;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 350px;
  border-radius: 10px;
  right: 10px;
  top: 10px;
  background-color: white;
`